/*jslint browser */
/*global process */

import AdminBarView from "../view/admin.bar.view";
import DumpService from "../service/dump.service";
import Dump from "../model/dump.model";

var $ = jQuery;

/**
 *
 */
export default class AdminBarController
{
    /**
     *
     * @private
     */
    private _adminBarView: AdminBarView;
    private _dumpService: DumpService;

    /**
     *
     * @param adminBarView
     * @param dumpService
     */
    constructor(adminBarView: AdminBarView, dumpService: DumpService) {
        this._adminBarView = adminBarView;
        this._dumpService = dumpService;

        this.addDumps();
        this.refreshDumps(this._dumpService.dumps);
        this.refreshCache();
        this.refreshDatabase();
    }

    /**
     *
     */
    public addDumps(): void {
        const dump = this._adminBarView.getDumpObject();
        const ob = this;
        dump.each(function () {
            const dump = new Dump();
            dump.message = $(this).html();
            ob._dumpService.add(dump);
        })
    }

    /**
     *
     */
    public refreshDumps(dumps: Dump[]): void {
        this._adminBarView.renderDumps(dumps);
        this._adminBarView.renderDumpsCount(dumps.length);
    }

    /**
     *
     */
    public refreshCache(): void {
        this._adminBarView.renderCache();
        this._adminBarView.renderCacheCount();
    }

    /**
     *
     */
    public refreshDatabase(): void {
        this._adminBarView.renderDatabase();
        this._adminBarView.renderDatabaseCount();
    }
}